module.exports = __webpack_public_path__ + "img/shareBottom.94e15365.jpg";